import { RouterModule } from '@angular/router';
import { LoginComponent } from 'app/components/login/login.component';
import { ForbiddenComponent } from './components/login/forbidden/forbidden.component';
import { LegacyBypassComponent } from './components/login/legacyBypass.component';
import { FaqComponent } from 'app/components/faq/faq.component';
import { AuthGuardService } from '@sc/pas-common';
import { LegacyComponent } from './components/legacy/legacy.component';
import { MaintenanceComponent } from './components/login/maintenance/maintenance.component';
import { ClaimComponent } from 'app/components/claim/claim.component';
import { AutoPlanComponent } from 'app/components/auto-plan/auto-plan.component';
import { NewsComponent } from 'app/components/news/news.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SeachPolicyComponent } from './components/search-policy/search-policy.component';
import { AllQuotationsComponent } from './components/all-quotations/all-quotations.component';
import { RenovationsComponent } from './components/renovations/renovations.component';
import { ClientsDebtsComponent } from './components/clients-debts/clients-debts.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { SingleSignatureCreditComponent } from './components/single-signature-credit/single-signature-credit.component';
// tslint:disable-next-line:max-line-length
import { PolicyCancellationDetailsComponent } from './components/shared/notification/policy-cancellation-details/policy-cancellation-details.component';
import { ImpersonatedLoginComponent } from './components/login/impersonated-login/impersonated-login.component';
import { RetirementInsuranceComponent } from './components/retirement-insurance/retirement-insurance.component';
import { ImpersonationGuardService } from '@sc/pas-common';
import { SupportPasComponent } from './components/support-pas/support-pas.component';
var ɵ0 = function () { return import("./modules/my-account/my-account.module.ngfactory").then(function (m) { return m.MyAccountModuleNgFactory; }); }, ɵ1 = function () { return import("./modules/commissions/commissions.module.ngfactory").then(function (m) { return m.CommissionsModuleNgFactory; }); }, ɵ2 = function () { return import("./modules/commissions-legacy/commissions-legacy.module.ngfactory").then(function (m) { return m.CommissionsLegacyModuleNgFactory; }); }, ɵ3 = function () { return import("./modules/protected-data/protected-data.module.ngfactory").then(function (m) { return m.ProtectedDataLoginModuleNgFactory; }); }, ɵ4 = function () { return import("./modules/digital-policy/digital-policy.module.ngfactory").then(function (m) { return m.DigitalPolicyModuleNgFactory; }); }, ɵ5 = function () { return import("./../../../../libs/sitio-seguro/src/lib/sitio-seguro.module.ngfactory").then(function (m) { return m.SitioSeguroModuleNgFactory; }); }, ɵ6 = function () { return import("./../../../../libs/leads-admin/src/lib/leads-admin.module.ngfactory").then(function (m) { return m.LeadsAdminModuleNgFactory; }); }, ɵ7 = function () { return import("./../../../../libs/leads-admin/src/lib/components/contact-form/leads-contact.module.ngfactory").then(function (m) { return m.LeadsContactModuleNgFactory; }); }, ɵ8 = function () { return import("./modules/integral-trade/integral-trade.module.ngfactory").then(function (m) { return m.IntegralTradeModuleNgFactory; }); }, ɵ9 = function () { return import("./modules/personal-accidents/personal-accidents.module.ngfactory").then(function (m) { return m.PersonalAccidentsModuleNgFactory; }); }, ɵ10 = function () { return import("./modules/ca7-claim/ca7-claim.module.ngfactory").then(function (m) { return m.Ca7ClaimModuleNgFactory; }); }, ɵ11 = {
    branch: 'auto'
}, ɵ12 = function () { return import("./modules/ca7-claim/ca7-claim.module.ngfactory").then(function (m) { return m.Ca7ClaimModuleNgFactory; }); }, ɵ13 = {
    branch: 'moto'
}, ɵ14 = function () { return import("./modules/claim-oorr/claim-oorr.module.ngfactory").then(function (m) { return m.ClaimOORRModuleNgFactory; }); }, ɵ15 = function () { return import("./modules/renewals/renewals-view.module.ngfactory").then(function (m) { return m.RenewalsViewModuleNgFactory; }); }, ɵ16 = function () { return import("./modules/ca7-car/ca7-car.module.ngfactory").then(function (m) { return m.CarPolicyChangeModuleNgFactory; }); }, ɵ17 = function () { return import("./../../../../libs/thirdparty-claim/src/lib/thirdparty-claim.module.ngfactory").then(function (m) { return m.ThirdpartyClaimModuleNgFactory; }); }, ɵ18 = function () { return import("./modules/notification-underwriting/notification-underwriting.module.ngfactory")
    .then(function (m) { return m.NotificationUnderwritingModuleNgFactory; }); }, ɵ19 = function () { return import("./../../../../libs/policy-detail/src/lib/policy-details.module.ngfactory").then(function (m) { return m.PolicyDetailsModuleNgFactory; }); }, ɵ20 = function () { return import("./modules/car-quote-lite/car-quote-lite.module.ngfactory").then(function (m) { return m.CarQuoteLiteModuleNgFactory; }); }, ɵ21 = function () { return import("./../../../../libs/car-lite/src/lib/car-lite.module.ngfactory").then(function (m) { return m.CarLiteModuleNgFactory; }); }, ɵ22 = function () { return import("./../../../../libs/car-issue/src/lib/car-issue.module.ngfactory").then(function (m) { return m.CarIssueModuleNgFactory; }); }, ɵ23 = function () { return import("./modules/car-unified/car-unified.module.ngfactory").then(function (m) { return m.CarUnifiedModuleNgFactory; }); }, ɵ24 = function () { return import("./modules/policy-lists/policy-lists.module.ngfactory").then(function (m) { return m.PolicyListsModuleNgFactory; }); }, ɵ25 = function () { return import("./../../../../libs/policy-change/src/lib/policy-change.module.ngfactory").then(function (m) { return m.PolicyChangeModuleNgFactory; }); };
var appRoutes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'legado',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: LegacyComponent
    },
    {
        path: 'planes',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: AutoPlanComponent
    },
    {
        path: 'siniestros',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: ClaimComponent
    },
    {
        path: 'mi-cuenta',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: ɵ0,
    },
    {
        path: 'comisiones',
        canActivate: [AuthGuardService],
        loadChildren: ɵ1,
    },
    {
        path: 'comisiones-legado',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: ɵ2,
    },
    {
        path: 'info-protegida',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: ɵ3,
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent
    },
    {
        path: 'legacyToken',
        component: LegacyBypassComponent
    },
    {
        path: 'faq',
        component: FaqComponent
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent
    },
    {
        path: 'aceptacion-poliza-digital',
        loadChildren: ɵ4,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'sitio-seguro',
        loadChildren: ɵ5,
        canActivate: [AuthGuardService, ImpersonationGuardService],
    },
    {
        path: 'admin-leads',
        loadChildren: ɵ6,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'admin-leads/editar-contacto',
        loadChildren: ɵ7,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cotizador-integral-comercio',
        loadChildren: ɵ8,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cotizador-accidentes-personales',
        loadChildren: ɵ9,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'denuncia-auto',
        loadChildren: ɵ10,
        canActivate: [AuthGuardService, ImpersonationGuardService],
        data: ɵ11
    },
    {
        path: 'denuncia-moto',
        loadChildren: ɵ12,
        canActivate: [AuthGuardService, ImpersonationGuardService],
        data: ɵ13
    },
    {
        path: 'denuncia-riesgos-varios',
        loadChildren: ɵ14,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'renovaciones',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: ɵ15
    },
    {
        path: 'auto',
        loadChildren: ɵ16,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'novedades',
        component: NewsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'creditos-sola-firma',
        component: SingleSignatureCreditComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'seguros-de-retiro',
        component: RetirementInsuranceComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'inicio',
        component: DashboardComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'buscador-poliza',
        component: SeachPolicyComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'mis-cotizaciones',
        component: AllQuotationsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'centro-renovaciones',
        component: RenovationsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'clientes-con-deudas',
        component: ClientsDebtsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cobranzas',
        component: PaymentsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cancelacion-poliza/:notificationId',
        component: PolicyCancellationDetailsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'reclamos-terceros',
        loadChildren: ɵ17,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'notificacion-fuera-pauta',
        loadChildren: ɵ18,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'detalle-poliza',
        loadChildren: ɵ19,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'auto-lite',
        loadChildren: ɵ20,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'car-lite',
        loadChildren: ɵ21,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'emision',
        loadChildren: ɵ22,
        canActivate: [AuthGuardService]
    },
    {
        path: 'auto-unified',
        loadChildren: ɵ23
    },
    {
        path: 'login-impersonificado',
        component: ImpersonatedLoginComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'soporte-pas',
        component: SupportPasComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'polizas',
        loadChildren: ɵ24,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'endoso',
        loadChildren: ɵ25,
        canActivate: [AuthGuardService]
    },
    {
        path: '**',
        redirectTo: '/inicio'
    }
];
// Cambiar 'useHash' a 'true' si queremos usar hash en la URL
export var routing = RouterModule.forRoot(appRoutes);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25 };
